import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent } from '@ecom/ui/card';

export const Route = createFileRoute('/(app)/products/')({
  component: ProductsPage,
});

function ProductsPage() {
  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Products</h1>
      <Card>
        <CardContent className="p-8 text-center text-muted-foreground">
          Product listing — connect a shop and sync to populate.
        </CardContent>
      </Card>
    </div>
  );
}
